import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import materialListAction from './materialList.action.json' with { type: 'json' }
import { materialObject } from '../materialObject'

export const materialExpression = expression(materialObject.shape)

const materialListDefinition = defineAction({
  ...materialListAction,

  input: z.object({
    filter: materialExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      name: 'Nome',
      type: 'Tipo',
      buyDate: 'Data de compra',
      supplier: 'Fornecedor',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(materialObject),
    count: z.number(),
  }),
})

export default materialListDefinition
